import { Attachemnt } from './../../model/attachment.model';
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import {  ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbNavContent, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {NgForm, FormControl, FormBuilder, FormGroup} from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { SendingIdService } from 'src/app/services/sending-id.service';
import { RequirementService } from 'src/app/services/requirement.service';
import {getUserInfo} from '@util/auth/helpers';
import {UsersService} from '@services/users.service';
import { JsonPipe } from '@angular/common';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { DomainConfigComponent } from '@app/domain-config.component';

@Component({
    selector: 'app-signature-attachment',
    templateUrl: './signature-attachment.component.html',
    styleUrls: ['./signature-attachment.component.scss'],
    standalone: false
})
export class SignatureAttachmentComponent implements OnInit {
  @Input() service: string;
  @Input() typeId: string;
  @Input() requirementId: string;
  @Output() insertAttach = new EventEmitter<boolean>();
  private fb: FormBuilder;
  files: any[] = [];
  documents: any[] = []; // Array para manejar múltiples documentos (solo archivo y título)
  name: string = '';
  email: string = '';
  signingparties = []; // Firmantes globales que se aplicarán a todos los documentos
  validEmailFormat = false;
  createdBy = '';
  loading: boolean = false;
  sentId: number;
  newAttachment: Attachemnt = new Attachemnt();
  signatureType: string = 'fea'; // Tipo de firma por defecto: FEA
  showMultipleSignatureTypes: boolean = false; // Mostrar selector de tipo de firma
  private _signaturesAvailable: { simple: number | null; fea: number | null; facial: number | null } | null = null;

  @Input()
  set signaturesAvailable(value: { simple: number | null; fea: number | null; facial: number | null } | null) {
    this._signaturesAvailable = value;
    this.applyAvailableSignatureType();
  }

  get signaturesAvailable() {
    return this._signaturesAvailable;
  }
  // var for messages\
  signature: '';
  errorMessage: string = '';
  successMessage: string = '';
  // requirementId = '';
  private _success = new Subject<string>();
  private _error = new Subject<string>();
  processedDocumentsCount: number = 0; // Contador para rastrear documentos procesados

  constructor(
    private activatedRoute: ActivatedRoute,
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private sendIdServ: SendingIdService,
    private _requirements: RequirementService,
    private usersService: UsersService,
    private domainConfigComponent: DomainConfigComponent
  ) {
    // Verificar si se debe mostrar el selector de tipo de firma
    this.showMultipleSignatureTypes = this.domainConfigComponent.getConfigFlagFirma('multiplefirmas') || false;
    console.log("showMultipleSignatureTypes",this.domainConfigComponent);
  }

  ngOnInit() {
    const userInfo = getUserInfo();
    this.usersService.getUser(userInfo.data.id).subscribe((response: any) =>
      this.createdBy = response.result.name
    );
    // this.requirementId = this.activatedRoute.snapshot.paramMap.get('requirementId');
    this.sendIdServ.currentMessage.subscribe((id) => (this.sentId = id));
    this.messageSubmitForm();
  }
  closeModal() {
    this.activeModal.close('Modal Closed');
  }

  private applyAvailableSignatureType() {
    const stock = this.signaturesAvailable;
    if (!stock || !this.showMultipleSignatureTypes || this.signatureType === 'docusign') {
      return;
    }
    const advanced = stock.fea;
    const simple = stock.simple;
    if (this.signatureType === 'fea' && (advanced === null || advanced <= 0) && simple !== null && simple > 0) {
      this.signatureType = 'simple';
    }
  }

  get selectedSignatureAvailable(): number | null {
    if (!this.signaturesAvailable) {
      return null;
    }
    if (this.signatureType === 'simple') {
      return this.signaturesAvailable.simple;
    }
    if (this.signatureType === 'fea') {
      return this.signaturesAvailable.fea;
    }
    return null;
  }
  getFormData(id: string, body) {
    const formData: FormData = new FormData();
    formData.append('file', body.file);
    formData.append(id, String(body.requirementid));
    formData.append('note', body.note);
    return formData;
  }

  createFields(form: NgForm) {
    if (form.valid) {
      const value = form.form.value;
      this.signingparties.push({
        name: value.name,
        email: value.email,
        lastname: value.lastname,
        identification: value.identification,
        phone: value.phone
      });
      form.resetForm();
    }
  }

  removeField(index: number) {
    this.signingparties.splice(index, 1);
  }
  validateEmail(mail) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(mail);
  }

  validateEmailFormat(mail) {
      this.validEmailFormat = !this.validateEmail(mail);
  }
  showConfirmModal(message: string) {
    const modalRef = this.modalService.open(ConfirmModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.message = message;
  }
  submitForm(form: NgForm) {
    // Validar que haya firmantes y que todos los documentos tengan título
    if (this.signingparties.length === 0) {
      this._error.next('Error: Debe agregar al menos un firmante.');
      return;
    }

    const invalidDocuments = this.documents.filter(doc =>
      !doc.title || !doc.title.trim()
    );

    if (invalidDocuments.length > 0) {
      this._error.next('Error: Todos los documentos deben tener un título.');
      return;
    }

    if (this.selectedSignatureAvailable !== null && this.selectedSignatureAvailable <= 0) {
      this._error.next('Error: No quedan firmas disponibles para el tipo seleccionado.');
      return;
    }

    if (this.documents.length > 0) {
      this.loading = true;
      this.processedDocumentsCount = 0;
      const totalDocuments = this.documents.length;
      let uploadedCount = 0;
      const documentsWithAttachmentId: { attachmentId: number; name: string }[] = [];
      const uploadErrors: string[] = [];

      const trySendBatch = () => {
        if (uploadedCount !== totalDocuments) return;
        if (documentsWithAttachmentId.length === 0) {
          this.loading = false;
          this._error.next('Error: No se pudo subir ningún archivo.');
          if (uploadErrors.length > 0) {
            uploadErrors.forEach(msg => this.showConfirmModal(msg));
          }
          return;
        }
        const batchPayload = {
          name: `Transacción Requerimiento ${this.requirementId}`,
          external_reference: String(this.requirementId),
          reference: +this.requirementId,
          createdBy: this.createdBy,
          signatureType: this.signatureType,
          signingparties: this.signingparties,
          documents: documentsWithAttachmentId
        };
        this._requirements.createSignatureBatch(batchPayload).subscribe(
          (resp2: any) => {
            const result = JSON.parse(JSON.stringify(resp2));
            this.loading = false;
            if (result.success === true || (result.result && result.result.success === true)) {
              this._success.next(`Se procesaron correctamente ${documentsWithAttachmentId.length} documento(s).`);
              this.activeModal.dismiss();
              this.insertAttach.emit(true);
            } else {
              const errorMsg = result.result?.message || result.message || 'Error al crear la firma en lote';
              this._error.next(errorMsg);
              this.showConfirmModal(errorMsg);
            }
          },
          (error) => {
            this.loading = false;
            const errorMsg = error.error?.message || error.message || 'Error al enviar documentos a TuFirma';
            this._error.next(errorMsg);
            this.showConfirmModal(errorMsg);
          }
        );
      };

      this.documents.forEach((document, index) => {
        const file = new File(
          [document.file],
          document.file.name.split('.').slice(0, -1).join('.') + new Date().getTime().toString() + '_' + index + '.pdf'
        );
        const body = {
          requirementid: this.sentId,
          note: document.file.note || '',
          file
        };
        const formData = this.getFormData(this.typeId, body);

        this._requirements.uploadOneFile(formData, this.service).subscribe(
          (resp: any) => {
            uploadedCount++;
            if (resp.error) {
              uploadErrors.push(`Error al subir "${document.file.name}": ${resp.error.message || 'Error desconocido'}`);
            } else {
              documentsWithAttachmentId.push({
                attachmentId: resp.result.id,
                name: document.title
              });
            }
            trySendBatch();
          },
          (error) => {
            uploadedCount++;
            uploadErrors.push(`Error al subir "${document.file.name}": ${error.message || 'Error desconocido'}`);
            trySendBatch();
          }
        );
      });
    } else {
      this._error.next('Error: No se ha adjuntado ningún archivo!!!');
    }
  }
  // MESSAGE FOR ERROR OR SUCCES
  messageSubmitForm() {
    this._success.subscribe((message) => (this.successMessage = message));
    this._success
      .pipe(debounceTime(2000))
      .subscribe(() => (this.successMessage = ''));
    this._error.subscribe((message) => (this.errorMessage = message));
    this._error
      .pipe(debounceTime(2000))
      .subscribe(() => (this.errorMessage = ''));
  }
  // DONE
  // retriving files - se llama cuando se carga un archivo
  retrieveFiles(event) {
    // Cuando se carga un archivo (o archivos), agregar solo los archivos nuevos
    if (event && event.length > 0) {
      // Identificar archivos nuevos comparando con los que ya tenemos
      const newFiles = event.filter(file => {
        // Verificar si el archivo ya existe en nuestra lista
        return !this.files.some(existingFile => 
          existingFile.name === file.name && 
          existingFile.size === file.size &&
          existingFile.lastModified === file.lastModified
        );
      });

      // Crear documentos solo para los archivos nuevos (solo archivo y título)
      newFiles.forEach((file) => {
        const nameWithoutExt = file.name.replace(/\.[^/.]+$/, '');
        const newDocument = {
          file: file,
          title: nameWithoutExt
        };
        this.documents.push(newDocument);
        this.files.push(file);
      });
    }
  }

  // Eliminar un documento de la lista
  removeDocument(index: number) {
    this.documents.splice(index, 1);
    this.files.splice(index, 1);
  }
}
